import ExternalLinksBaseHandler from '../external_links_base_handler';
import ServiceFactory from '../../../../services/service_factory';
import {CHANNEL_ELEMENTS, CHANNEL_SOURCE} from "../../../../../../common/const/casinofied-analytics-consts";
import {AreaType} from "@sparkware/uc-sdk-core";
import {PENDING_PLAY_POST_ACTIONS} from "./pending_play_handler_consts";

export default class ExternalLinksPendingPlayHandler extends ExternalLinksBaseHandler {
    static CLASS = 'ExternalLinksPendingPlayHandler';
    static HandlerName = 'pending_play';

    executePostMessageAction(postMessageData) {

        const actionId = (postMessageData.ActionId || '').toString().toLowerCase();

        if(actionId === PENDING_PLAY_POST_ACTIONS.QUICK_DEPOSIT) {
            this.close();
            this._openQuickDeposit();
        } else {
            if(postMessageData.Token) {
                this.close();
                ServiceFactory.create().pendingActionService().executeAction();
            } else {
                if (actionId === PENDING_PLAY_POST_ACTIONS.CLOSE) {
                    this.close();
                }
                this._clearOpenGamePendingAction();
            }
        }


    }

    _openQuickDeposit(postMessageData) {
        let options = {};
        if (postMessageData.PromCode) {
            options.PromCode = postMessageData.PromCode;
        }

        this._serviceFactory.cashierProxyService().openDeposit({
            ...options,
            channel: {
                source: CHANNEL_SOURCE.pendingPlay,
                area: AreaType.PendingAction,
                element: CHANNEL_ELEMENTS.depositButton
            }
        });
    }

    onBtnCloseClicked() {
        super.onBtnCloseClicked();
        this._clearOpenGamePendingAction();
    }

    getHandlerName() {
        return ExternalLinksPendingPlayHandler.HandlerName;
    }

    _clearOpenGamePendingAction() {
        ServiceFactory.create().pendingActionService().clearPendingAction();
    }

}